import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const DeleteContextFetcher = (uid, accessToken) => {
  return axios.delete(`${apiUrlInternal}/contexts/${uid}`, addAuthToFetchOpts(accessToken, {})).then(res => res.data);
}

export const useDeleteContextTask = (fetcher = DeleteContextFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['delete-contexts'],
    (accessToken, uid) => fetcher(uid, accessToken),
    {onSuccess: () => queryClient.invalidateQueries('delete-contexts')}
  )
}
